import React from "react";

import { FileGeneratorUI } from "./components";

const Submissions = () => {
  return (
    <FileGeneratorUI
      scope="SUBMISSIONS|ALL|V1"
      title="Generate Submission CSV File."
      entity="submissions"
    />
  );
};

export { Submissions };
